import * as React from 'react';
import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { getShippingQuoteError } from '@/redux/modules/checkoutShippingQuote/checkoutShippingQuote.selectors';
import { ShippingMethods } from '@/enums/shippingMethod';
import { shippingProviders } from '@/enums/shippingProviders';
import { ShippingQuote } from '@/types/ShippingQuote';
import { useAppSelector } from '@/redux/hooks';
import Radio from '@liveauctioneers/caterwaul-components/lib/Radio/Radio';
import ShippingMethodLabel from '../ShippingMethodLabel';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

export type LiveShippingShippingMethodProps = {
    loading?: boolean;
    numberOfItems: number;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    selectedName?: string;
    shippingQuote: ShippingQuote;
};

const LiveShippingShippingMethod = ({
    loading,
    numberOfItems,
    onClick,
    selectedName,
    shippingQuote,
}: LiveShippingShippingMethodProps) => {
    const quoteErrorCode = useAppSelector((state) => getShippingQuoteError(state));

    const { currency = 'USD', shippingProvider, total = 0, transitDays } = shippingQuote;

    return (
        <StyledRadio
            disabled={Boolean(quoteErrorCode) || loading}
            label={
                <ShippingMethodLabel
                    info={
                        Boolean(quoteErrorCode) ? (
                            <StyledErrorText
                                colorError
                                secondary
                            >
                                <FormattedMessage
                                    id={
                                        quoteErrorCode === 500
                                            ? 'checkout.shippingMethod.quoteError500'
                                            : 'checkout.shippingMethod.quoteError400'
                                    }
                                />
                            </StyledErrorText>
                        ) : (
                            <FormattedMessage
                                id={
                                    Boolean(transitDays)
                                        ? 'checkout.shippingMethod.method.laShippingDetails'
                                        : 'checkout.shippingMethod.method.laShippingDetailsNoTransitDays'
                                }
                                values={{
                                    days: transitDays || 1,
                                    numberOfItems,
                                    shippingProvider: shippingProviders[shippingProvider],
                                }}
                            />
                        )
                    }
                    popoverContent={<FormattedMessage id="checkout.shippingMethod.popovers.laShip" />}
                    price={
                        !Boolean(quoteErrorCode) && (
                            <FormattedNumber
                                currency={currency}
                                key="checkout-shipping-method-live-shipping-price"
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                                style="currency"
                                value={Number(total)}
                            />
                        )
                    }
                    title={<FormattedMessage id="checkout.shippingMethod.method.A" />}
                />
            }
            name={ShippingMethods.LiveShipping}
            onClick={onClick}
            selectedName={selectedName}
            testid="shippingMethodLiveShipping"
        />
    );
};

export default LiveShippingShippingMethod;

const StyledRadio = styled(Radio).attrs(() => ({
    radioCircleClassName: 'radioCircleClassName',
}))`
    padding-left: 26px;
    .radioCircleClassName {
        top: 2px;
        left: 0;
    }

    & > span:first-of-type {
        width: 100%;
    }
`;

const StyledErrorText = styled(Text)`
    margin-top: 2px;
`;
